var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3991 7.65566C53.5753 6.83043 52.2387 6.82901 51.4149 7.65216L26.0953 32.9049L16.9601 22.9831C16.1707 22.1263 14.8361 22.0707 13.9779 22.86C13.1203 23.6494 13.0654 24.9846 13.8547 25.8422L24.4779 37.3792C24.8669 37.802 25.4114 38.0476 25.9855 38.0595C26.0009 38.0602 26.0158 38.0602 26.0306 38.0602C26.5885 38.0602 27.1252 37.8386 27.5206 37.4446L54.395 10.6406C55.2209 9.81757 55.2223 8.4809 54.3991 7.65566Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8894 25.8894C52.7237 25.8894 51.7789 26.8342 51.7789 28C51.7789 41.1122 41.1122 51.7789 28 51.7789C14.8886 51.7789 4.22111 41.1122 4.22111 28C4.22111 14.8886 14.8886 4.22111 28 4.22111C29.1657 4.22111 30.1106 3.27633 30.1106 2.11061C30.1106 0.944781 29.1657 0 28 0C12.5606 0 0 12.5606 0 28C0 43.4387 12.5606 56 28 56C43.4387 56 56 43.4387 56 28C56 26.8343 55.0552 25.8894 53.8894 25.8894Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6863e1d8.svg";
export { ForwardRef as ReactComponent };